import Vue from 'vue'

import ElementUI from 'element-ui'
import elementUILocale from 'element-ui/lib/locale'

import 'element-ui/lib/theme-chalk/index.css'

let messageModules = {}

// ElementUI locale packs for the languages in AVAILABLE_LOCALES
const localePacks: { [name: string]: () => Promise<any> } = {
  'ar': () => import('element-ui/lib/locale/lang/ar'),
  'de': () => import('element-ui/lib/locale/lang/de'),
  'el': () => import('element-ui/lib/locale/lang/el'),
  'en': () => import('element-ui/lib/locale/lang/en'),
  'es': () => import('element-ui/lib/locale/lang/es'),
  'fi': () => import('element-ui/lib/locale/lang/fi'),
  'fr': () => import('element-ui/lib/locale/lang/fr'),
  'it': () => import('element-ui/lib/locale/lang/it'),
  'ja': () => import('element-ui/lib/locale/lang/ja'),
  'nl': () => import('element-ui/lib/locale/lang/nl'),
  'pt': () => import('element-ui/lib/locale/lang/pt'),
  'tr-TR': () => import('element-ui/lib/locale/lang/tr-TR')
}

function loadLocalePack (name: string) {
  const load = localePacks[name]
  return load ? load() : Promise.reject(new Error(`No ElementUI locale pack ${name}`))
}

function getLocaleCandidates (locale: string) {
  const normalizedLocale = (locale || '').replace('_', '-')
  const parts = normalizedLocale.split('-')
  const language = parts[0]
  const region = parts[1]
  const normalizedRegion = region ? `${language}-${region.toUpperCase()}` : ''

  return Array.from(new Set([
    normalizedLocale,
    normalizedRegion,
    language
  ].filter(Boolean)))
}

export default class ElementUIWrapper {

  static async init (locales: string[]) {
    const uniqueLocales = Array.from(new Set((locales || []).concat(['en-gb'])))
    for (let locale of uniqueLocales) {
      const candidates = getLocaleCandidates(locale)
      let loaded = false
      try {
        for (let candidate of candidates) {
          try {
            messageModules[locale] = await loadLocalePack(candidate)
            loaded = true
            break
          } catch (err) {
            // try next locale candidate
          }
        }

        if (!loaded) {
          // eslint-disable-next-line no-console
          console.error('Failed to load ElementUI locale pack for', locale, '-> falling back to en')
          messageModules[locale] = await loadLocalePack('en')
        }
      } catch (err) {
        messageModules[locale] = await loadLocalePack('en')
      }
    }

    Vue.use(ElementUI)
  }

  static set locale (locale: string) {
    const pack = messageModules[locale] || messageModules['en-gb']
    if (pack && pack.default) {
      elementUILocale.use(pack.default)
    }
  }

}
